import { render, staticRenderFns } from "./ArticlePdfPersonalizado.vue?vue&type=template&id=36f329e4&"
import script from "./ArticlePdfPersonalizado.vue?vue&type=script&lang=js&"
export * from "./ArticlePdfPersonalizado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports